import {getGenericContentLink, type GenericContent} from '../../../../../../brand/lib/types/contentful'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {Button, Heading, Image} from '@primer/react-brand/esm'
import {Eyebrow} from '../../_shared/Eyebrow/Eyebrow'

import Icon from './_icon.svg'

import Styles from './DeepDive.module.css'

type Props = {
  content: GenericContent
  links: GenericContent[]
  location: string
}

export function DeepDive(props: Props) {
  const {content, links, location} = props
  const {heading, label} = content.fields

  const title = heading
  const eyebrow = label?.fields.text

  return (
    <div className={Styles.DeepDive}>
      <div className={Styles.Wrapper}>
        {eyebrow && <Eyebrow className={Styles.Eyebrow} text={eyebrow} />}

        {title && (
          <div>
            <Heading className={Styles.Title} data-heading="1" as="h1">
              {title}
            </Heading>
          </div>
        )}
      </div>

      <div className={Styles.Grid}>
        {links?.map(item => {
          const link = getGenericContentLink(item)?.fields

          return link ? (
            <Button
              key={item.sys.id}
              className={Styles.Button}
              as="a"
              variant="subtle"
              href={link.href}
              {...getAnalyticsEvent({
                action: link.text,
                tag: 'a',
                context: 'link',
                location,
              })}
            >
              {link.text}

              <Image src={Icon} width="25" height="25" alt="" />
            </Button>
          ) : null
        })}
      </div>
    </div>
  )
}
